export default "__VITE_ASSET__C4hN3mxv__"